import { dataHooks as createDataHooks } from '@wix/data-hooks'

export const wixStudioTemplateDataHooks = createDataHooks<{
  back: {}
  baseTemplate: {}
}>('wix-studio-template')
